<ng-template vdrDialogTitle>{{
  "requestPurchase.confirm" | translate
}}</ng-template>
<p>{{ message | translate }}</p>

<ng-container *ngFor="let groupForm of requestForm.controls">
  <form class="form" [formGroup]="groupForm">
    <h3 style="margin-bottom: 1rem">
      {{ groupForm.value.name }}
    </h3>
    <div class="form-grid">
      <vdr-form-field [label]="'requestPurchase.note' | translate" for="note">
        <input type="text" id="note" formControlName="note" />
      </vdr-form-field>

      <vdr-form-field
        [label]="'requestPurchase.supplier' | translate"
        for="note"
      >
        <ng-select
          [items]="suppliers$ | async"
          appendTo="body"
          bindLabel="name"
          [addTag]="false"
          [multiple]="false"
          [hideSelected]="true"
          [trackByFn]="trackByFn"
          [minTermLength]="2"
          [typeahead]="input$"
          [loading]="isLoading"
          formControlName="supplier"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="item-row">
              <clr-icon shape="bundle" class="is-solid"></clr-icon>
              <span class="mx-1">{{ item.name }}</span>
            </span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span class="item-row">
              <clr-icon shape="bundle" class="is-solid"></clr-icon
              ><span class="mx-1"> {{ item.name }}</span>
            </span>
          </ng-template>
        </ng-select>
      </vdr-form-field>

      <vdr-form-field
        [label]="'requestPurchase.retailer' | translate"
        for="note"
      >
        <ng-select
          [items]="retailers$ | async"
          appendTo="body"
          bindLabel="name"
          [addTag]="false"
          [multiple]="false"
          [hideSelected]="true"
          [trackByFn]="trackByFn"
          [minTermLength]="2"
          [typeahead]="inputRetailer$"
          [loading]="isLoadingRetailer"
          formControlName="retailer"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="item-row">
              <clr-icon shape="bundle" class="is-solid"></clr-icon>
              <span class="mx-1">{{ item.name }}</span>
            </span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span class="item-row">
              <clr-icon shape="bundle" class="is-solid"></clr-icon
              ><span class="mx-1">{{ item.name }}</span>
            </span>
          </ng-template>
        </ng-select>
      </vdr-form-field>
    </div>

    <ng-container formArrayName="requests">
      <div
        class="mt-2"
        *ngFor="
          let request of groupForm.controls.requests.controls;
          let i = index
        "
      >
        <div
          class="flex flex-row mt-1"
          style="justify-content: space-between; width: 100%"
        >
          <vdr-form-field
            [label]="'requestPurchase.productVariantName' | translate"
            style="width: 33%"
          >
            <input
              type="text"
              readonly
              id="sku"
              [formControl]="request.get('productVariant')"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'catalog.sku' | translate"
            style="width: 33%"
          >
            <input
              type="text"
              readonly
              id="sku"
              [formControl]="request.get('sku')"
            />
          </vdr-form-field>

          <vdr-form-field
            [label]="'requestPurchase.expectedDate' | translate"
            for="date"
            style="width: 33%"
          >
            <input
              type="date"
              [min]="today"
              id="expectedDate"
              required
              [formControl]="request.get('expectedDate')"
            />
          </vdr-form-field>
        </div>
        <div
          class="flex flex-row mt-1"
          style="justify-content: space-between; width: 100%"
        >
          <vdr-form-field
            [label]="'requestPurchase.orderQuantity' | translate"
            style="width: 33%"
          >
            <input
              type="number"
              readonly
              id="orderQuantity"
              [formControl]="request.get('orderQuantity')"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'requestPurchase.currentStock' | translate"
            style="width: 33%"
          >
            <input
              type="number"
              readonly
              id="stockOnHand"
              [formControl]="request.get('stockOnHand')"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'requestPurchase.quantityNeeded' | translate"
            style="width: 33%"
          >
            <input
              type="number"
              id="quantity"
              [formControl]="request.get('quantity')"
              readonly
            />
          </vdr-form-field>
        </div>
        <div
          *ngIf="groupForm.controls.requests.controls.length > 1"
          class="mx-auto"
          style="
            width: 80%;
            border-bottom: 0.5px dashed #ccc;
            padding-bottom: 0.7rem;
          "
        ></div>
      </div>
    </ng-container>
  </form>

  <div
    *ngIf="requestForm.controls.length > 1"
    class="mx-auto"
    style="width: 100%; border-bottom: 0.5px solid grey; padding-bottom: 1rem"
  ></div>

  <div
    style="
      margin-top: 1rem;
      margin-bottom: 1rem;
      border-bottom: 1px solid #ccc;
      padding-bottom: 0.7rem;
    "
  >
    <label
      style="
        font-size: var(--font-size-sm);
        color: var(--color-weight-800);
        margin-bottom: 1rem;
        display: inline-block;
      "
      >{{ "requestPurchase.images-section" | translate }}</label
    >
    <image-selector
      [assets]="groupForm.controls.images.assets"
      [featuredAsset]="groupForm.controls.images.featuredAsset"
      (change)="
        groupForm.controls.images.patchValue(
          $event.featuredAsset ? $event : null
        )
      "
    ></image-selector>
  </div>
</ng-container>

<p style="color: red">{{ error }}</p>

<ng-template vdrDialogButtons>
  <button
    type="submit"
    *ngIf="cancellable"
    (click)="cancel()"
    class="btn btn-secondary"
  >
    {{ "common.cancel" | translate }}
  </button>

  <button
    [disabled]="requestForm.invalid"
    type="button"
    class="btn btn-primary"
    (click)="select()"
  >
    {{ "requestPurchase.confirm" | translate }}
  </button>
</ng-template>
